define 'controller/CustomDropdownController', ['jquery', 'lib/kryptonite', 'lib/easy-autocomplete', 'lib/owl.carousel'], ($) ->
  class CustomDropdownController

    constructor: (@$el) ->
      @currentOptionIndex = 0
      @$dropDownOpener = @$el.find('.js-dropdown-opener')
      @$dropDownOptionsWrap = @$el.find('[data-controller-element=dropdown-options]')
      @$dropDownOption = @$dropDownOptionsWrap.find("[data-controller-element=dropdown-option]")
      @_init()

    _init: ->
      @_selectCustomDropdown()

    _selectCustomDropdown: ->
      self = @
      # REFACTOR HERE
      @$el.on 'click', '[data-controller-element=dropdown-opener], .js-dropdown-opener', (e) ->
        e.preventDefault()
        $opener = self.$el.find('.js-dropdown-opener')
        #cconsole.log("this", this)
        #console.log("$opener.not(this)", $opener.not(this))
        #$opener.not(this).removeClass('active')
        #$opener.not(this).parent().find('ul').slideUp()
        $this = $(@)
        $this.toggleClass('active')
        #self.$el.find("[data-controller-element=dropdown-options]").slideToggle()
        self.$el.find("ul").slideToggle()
        if $this.hasClass("active")
          $this.attr("aria-expanded", "true")
          $this.attr("aria-activedescendant", self.$el.find('.custom-dropdown__option.selected').attr("id"))
        else
          $this.attr("aria-expanded", "false")
          $this.attr("aria-activedescendant", "")

      @$el.on 'click', '[data-controller-element=dropdown-option], .custom-dropdown li', (e) ->
        self._selectOption(e)

      #@$el.on 'keydown', '[data-controller-element=dropdown-option], .custom-dropdown li', (e) ->
        #if e.key == "Enter"
          #e.click()
        #console.log("FOCUSS",e)

      $('body').on 'click', (e) ->
        if self.$dropDownOpener.hasClass('active') && !e.target.closest('.custom-dropdown')
          self.$dropDownOpener.click()

      @$dropDownOpener.on 'keydown', (e) ->
        $el = $(e.currentTarget)
        if self.$dropDownOpener.hasClass('active')
          if e.key == "Escape"
            self.$dropDownOpener.click()
          else if e.key == "ArrowDown"
            self._optionsNavigation("down")
          else if e.key == "ArrowUp"
            self._optionsNavigation("up")
        else
          if e.key == "ArrowDown" || e.key == "ArrowUp"
            self.$dropDownOpener.click()

    _selectOption: (e) ->
      $el = $(e.currentTarget)
      value = $el.data('value')
      text = $el.data('text')
      color = $el.find('.color-tile img').attr('src')
      $closestCustomDropdown = $el.closest('.custom-dropdown')
      $closestCustomDropdown.removeClass("custom-dropdown--error")
      $closestCustomDropdown.find('li').removeClass('selected')
      $closestCustomDropdown.find('li').attr("aria-selected", "false")
      $closestCustomDropdown.find('input').val(value)
      $closestCustomDropdown.find('.js-dropdown-opener .content').html(text).removeClass("placeholder")
      $closestCustomDropdown.find('.js-dropdown-opener .content-color img').attr('src', color)
      if $el.attr("id")?
        $closestCustomDropdown.find('.js-dropdown-opener').attr("aria-activedescendant", $el.attr("id"))
      $el.addClass('selected')
      $el.attr("aria-selected", "true")
      $closestCustomDropdown.find('.js-dropdown-opener').click()
      #$closestCustomDropdown.find('.js-dropdown-opener').removeClass('active') #covered by self.$dropDownOpener.click()
      #$el.parent('ul').slideUp() #covered by self.$dropDownOpener.click()

    _optionsNavigation: (direction) ->
      #if @$dropDownOptionsWrap.find(".selected").length > 0
        #@currentOptionIndex = @$dropDownOptionsWrap.find(".selected").index()

      if direction == "down"
        console.log("check", @currentOptionIndex < @$dropDownOption.length - 1)
        if @currentOptionIndex < @$dropDownOption.length - 1
          @currentOptionIndex++
        else
          @currentOptionIndex = 0
      else
        if @currentOptionIndex > 0
          @currentOptionIndex--
        else
          @currentOptionIndex = @$dropDownOption.length - 1

      @$dropDownOption.eq(@currentOptionIndex).addClass("current")
      console.log("currentOption", @$dropDownOption.eq(@currentOptionIndex))
      console.log("currentOptionIndex",@currentOptionIndex)
      @$dropDownOption.eq(@currentOptionIndex).focus()

    destroy: ->
      @$el.off()